import React from 'react';
import PropTypes from 'prop-types';
import { strings } from '../../../../localization';
import {EVENT_MEDIA_STATUS, EVENT_MEDIA_CAMERA_TYPE} from './eventMediaConstants';
import imageCamToggle from './images/cam-toggle-w64.svg';


export default class EventMediaMessageOverlay extends React.PureComponent {
    constructor(props) {

        super(props);

    }

    render() {

        var headerMessage;
        var subHeaderElement;
        var cameraName = strings.media_status_road_camera;
        let altCameraName = strings.media_status_cabin_camera;
        if (this.props.cameraType === EVENT_MEDIA_CAMERA_TYPE.CAMERA_CABIN) {
            cameraName = strings.media_status_cabin_camera;
            altCameraName = strings.media_status_road_camera;
        }
        switch (this.props.status) {
            case EVENT_MEDIA_STATUS.ERROR: // DEPRECATED_VIDEO_PREVIEW_REQUEST
                headerMessage = strings.error_occurred_please_try_again_later;
                if (this.props.createEventUserVideo) {
                    subHeaderElement = <button onClick={this.props.retry}>{strings.action_retry}</button>;
                }
                break;
            case EVENT_MEDIA_STATUS.ERROR_REQUEST_TIMEOUT:
                headerMessage = strings.media_status_error_request_timeout;
                subHeaderElement = <button onClick={this.props.retry}>{strings.action_retry}</button>;
                break;
            case EVENT_MEDIA_STATUS.ERROR_MQTT_FAILED:
                headerMessage = strings.media_status_error_mqtt_failed;
                subHeaderElement = <button onClick={this.props.retry}>{strings.action_retry}</button>;
                break;
            case EVENT_MEDIA_STATUS.ERROR_UPLOAD_FAILED:
                headerMessage = strings.media_status_error_upload_failed;
                subHeaderElement = <button onClick={this.props.retry}>{strings.action_retry}</button>;
                break;
            case EVENT_MEDIA_STATUS.ERROR_SHORT_FAILED:
                headerMessage = strings.media_status_error_short_failed;
                subHeaderElement = <button onClick={this.props.retry}>{strings.action_retry}</button>;
                break;
            case EVENT_MEDIA_STATUS.ERROR_RECORDING_FAIL:
                headerMessage = strings.media_status_error_recording_fail;
                subHeaderElement = <button onClick={this.props.retry}>{strings.action_retry}</button>;
                break;
            case EVENT_MEDIA_STATUS.ERROR_DOWNLOAD_FAILED:
                headerMessage = strings.media_status_error_download_failed;
                subHeaderElement = <button onClick={this.props.retry}>{strings.action_retry}</button>;
                break;
            case EVENT_MEDIA_STATUS.ERROR_MEDIA_FAILED:
                headerMessage = strings.media_status_error_media_failed;
                subHeaderElement = <button onClick={this.props.retry}>{strings.action_retry}</button>;
                break;
            case EVENT_MEDIA_STATUS.ERROR_PLAYBACK_FAILED:
                headerMessage = strings.media_status_error_playback_failed;
                subHeaderElement = <button onClick={this.props.retry}>{strings.action_retry}</button>;
                break;
            case EVENT_MEDIA_STATUS.CREATE_PREVIEW_VIDEO_REQUEST_SENT:
                headerMessage = strings.formatString(strings.media_status_x_camera_create_preview_video_request_sent, cameraName);
                subHeaderElement = <div className="pending-ellipsis"><div></div><div></div><div></div><div></div></div>;
                break;
            case EVENT_MEDIA_STATUS.MEDIA_INITIATED:
                headerMessage = strings.formatString(strings.media_status_x_camera_media_initiated, cameraName);
                subHeaderElement = <div className="pending-ellipsis"><div></div><div></div><div></div><div></div></div>;
                break;
            case EVENT_MEDIA_STATUS.MEDIA_CREATED:
                headerMessage = strings.formatString(strings.media_status_x_camera_media_created, cameraName);
                subHeaderElement = <div className="pending-ellipsis"><div></div><div></div><div></div><div></div></div>;
                break;
            case EVENT_MEDIA_STATUS.MEDIA_UPLOAD_INITIATED:
                headerMessage = strings.formatString(strings.media_status_x_camera_media_upload_initiated, cameraName);
                subHeaderElement = <div className="pending-ellipsis"><div></div><div></div><div></div><div></div></div>;
                break;
            case EVENT_MEDIA_STATUS.MEDIA_UPLOAD_COMPLETED:
                headerMessage = strings.formatString(strings.media_status_x_camera_media_upload_completed, cameraName);
                subHeaderElement = <div className="pending-ellipsis"><div></div><div></div><div></div><div></div></div>;
                break;
                                        
            case EVENT_MEDIA_STATUS.NOT_FOUND_PREVIEW_IMAGE:
            case EVENT_MEDIA_STATUS.SOURCE_AVAILABLE_WITHOUT_PREVIEW_IMAGE:
                headerMessage = <>
                    <span>
                    {strings.formatString(strings.preview_image_not_found_for_x_camera, cameraName)}
                    </span>
                    <span className="preview-image-not-found-call-to-action">
                        {strings.preview_image_not_found_for_x_camera_action_prefix}
                        <img src={imageCamToggle} style={{padding: "0 5px"}}/>
                        {strings.formatString(strings.preview_image_not_found_for_x_camera_action_suffix, altCameraName)}
                    </span>
                    </>
                break;
            default:
                return null; /* other states do not require overlay */
        }

        return (
            <div className="event-media-message-overlay">
                <h3>{headerMessage}</h3>
                <div className="event-media-message-overlay-subheader">{subHeaderElement}</div>
            </div>
        )
    }
}

EventMediaMessageOverlay.propTypes = {
    cameraType: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    retry: PropTypes.func.isRequired, /* for retry action */
};
